export const property = [
  {
    id: 1,
    img: "https://images.pexels.com/photos/1974596/pexels-photo-1974596.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
    //*used this way*/
    icon: `${require("../assets/icons/carouselHome.svg").default}`,
    title: "house",
  },
  {
    id: 2,
    img: "https://images.pexels.com/photos/936722/pexels-photo-936722.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
    icon: `${require("../assets/icons/carouselApartment.svg").default}`,
    title: "apartment",
  },
  {
    id: 3,
    img: "https://images.pexels.com/photos/265072/pexels-photo-265072.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
    icon: `${require("../assets/icons/carouselBusinessTrade.svg").default}`,
    title: "office",
  },
  {
    id: 4,
    img: "https://images.pexels.com/photos/3797503/pexels-photo-3797503.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
    icon: `${require("../assets/icons/carouselVilla.svg").default}`,
    title: "villa",
  },
  {
    id: 5,
    img: "https://images.pexels.com/photos/698170/pexels-photo-698170.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
    icon: `${require("../assets/icons/carouselLivingRoom.svg").default}`,
    title: "room",
  },
  {
    id: 6,
    img: "https://images.pexels.com/photos/1510173/pexels-photo-1510173.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
    icon: `${require("../assets/icons/carouselLivingRoom.svg").default}`,
    title: "condo",
  },
  {
    id: 7,
    img: "https://images.pexels.com/photos/6187660/pexels-photo-6187660.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
    icon: `${require("../assets/icons/carouselHome.svg").default}`,
    title: "mobile home",
  },
  {
    id: 8,
    img: "https://images.pexels.com/photos/4445317/pexels-photo-4445317.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
    icon: `${require("../assets/icons/carouselHome.svg").default}`,
    title: "town house",
  },
];
